export default __webpack_public_path__ + "static/media/orange-stroke.f3c5fe44.mp4";